import { render, staticRenderFns } from "./ImoFalForm6MenuForm.vue?vue&type=template&id=4a9efc49"
import script from "./ImoFalForm6MenuForm.vue?vue&type=script&lang=js"
export * from "./ImoFalForm6MenuForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports